var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2995 23.2396C23.9991 23.2396 28.6195 18.6192 28.6195 12.9196C28.6195 7.22003 23.9991 2.59961 18.2995 2.59961C12.5999 2.59961 7.97949 7.22003 7.97949 12.9196C7.97949 18.6192 12.5999 23.2396 18.2995 23.2396Z",
    fill: "#E6E5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1599 39.3393L8.83988 42.3593C8.70313 42.455 8.54536 42.5163 8.37989 42.5382C8.21443 42.5601 8.04613 42.5418 7.88922 42.4849C7.73231 42.428 7.59139 42.3342 7.47837 42.2114C7.36535 42.0886 7.28355 41.9404 7.23988 41.7793L5.87988 36.6793L12.9599 17.2793L20.2399 19.9993L16.2399 30.7393L12.9799 31.3193L14.9799 33.9793L13.1599 39.3393Z",
    fill: "#E6E5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 11.1795C21.3047 11.1795 22.4598 10.0244 22.4598 8.59953C22.4598 7.17464 21.3047 6.01953 19.8798 6.01953C18.4549 6.01953 17.2998 7.17464 17.2998 8.59953C17.2998 10.0244 18.4549 11.1795 19.8798 11.1795Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.98 27.8798C37.2377 27.8798 41.5 23.6176 41.5 18.3598C41.5 13.1021 37.2377 8.83984 31.98 8.83984C26.7222 8.83984 22.46 13.1021 22.46 18.3598C22.46 23.6176 26.7222 27.8798 31.98 27.8798Z",
    fill: "#B1B0F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7202 40.2187L42.3802 44.8987C42.3382 45.0466 42.2613 45.1823 42.1559 45.2942C42.0506 45.4062 41.9199 45.4913 41.7749 45.5422C41.6299 45.5932 41.4747 45.6086 41.3225 45.5871C41.1703 45.5656 41.0254 45.5079 40.9002 45.4187L36.9002 42.5587L30.6602 24.5587L37.4002 22.2188L40.8602 32.2187L38.8602 34.5187L42.0002 35.1987L43.7202 40.2187Z",
    fill: "#B1B0F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5997 16.7405C31.9142 16.7405 32.9797 15.6749 32.9797 14.3605C32.9797 13.046 31.9142 11.9805 30.5997 11.9805C29.2853 11.9805 28.2197 13.046 28.2197 14.3605C28.2197 15.6749 29.2853 16.7405 30.5997 16.7405Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeys);
export default __webpack_public_path__ + "static/media/keys.9f7e3a32d39164b41c61df1417c50807.svg";
export { ForwardRef as ReactComponent };